import React from 'react';

interface ProgressBarProps {
  progress: number;
  maxValue?: number;
  className?: string;
  showLabel?: boolean;
  label?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  maxValue = 100,
  className = "",
  showLabel = false,
  label
}) => {
  const percentage = progress === 0 || maxValue === 0 ? 0 : Math.min(Math.max((progress / maxValue) * 100, 0), 100);

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <div className="flex-1 h-1.5 bg-medium rounded-full overflow-hidden">
        <div
          className="h-full bg-success rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <div className="text-[#928881] text-base font-normal">
          {label || `${progress}/${maxValue}`}
        </div>
      )}
    </div>
  );
};
